import React from "react";
import { useNavigate } from "react-router-dom";
import PageHeader from "../../../components/common/PageHeader";
import StageForm from "../components/StageForm";
import { createStage } from "../api/stageService";
import { toast } from "react-toastify";

const CreateStage: React.FC = () => {
  const navigate = useNavigate();

  const handleCreate = async (data: {
    stage_name: string;
    description?: string;
    is_active: boolean;
  }) => {
    await createStage(data);
    toast.success("Stage added successfully");
    navigate("/stage");
  };

  return (
    <>
      <PageHeader
        title="Create Stage"
        breadcrumbs={[
          { label: "Home", path: "/dashboard" },
          { label: "Masters", path: "/stage" },
          { label: "Create Stage" },
        ]}
      />

      <StageForm
        onSubmit={handleCreate}
        submitLabel="Save"
      />
    </>
  );
};

export default CreateStage;
